import React from 'react';
import _ from 'lodash';
import styles from './UserEditForm.module.css';
import { withRouter } from 'Components/withRouter';
import UserEditPermissions from 'Components/UserEditPermissions';

class UserEditForm extends React.Component {
    
    constructor(props) {
        super(props);

        var initialState = {
            userId: '',
            userName: '',
            email: '',
            password: '',
            active: true,
            allow_uem: false,
            region: '',
            phone: '',
            defaultAccount: ''
        };

        if (props.editUser)
        {
            Object.assign(initialState, {
                userId: props.editUser.id,
                userName: props.editUser.name,
                email: props.editUser.email,
                password: props.editUser.new_password,
                confirmPassword: props.editUser.new_password,
                active: props.editUser.is_active,
                allow_uem: props.editUser.unsolicited_emails,
                region: props.editUser.region,
                phone: props.editUser.phone,
                defaultAccount: props.editUser.default_account
            });
        }

        if (props.currentUser) {
            _.forEach(props.currentUser.accounts, a => {
                var accountValue = a.value;
                Object.assign(initialState, {
                    ["UserCust" + accountValue]: (props.editUser ? _.some(props.editUser.accounts, ['value', accountValue]) : false)
                });
            });

            if (!props.editUser) {
                Object.assign(initialState, {
                    defaultAccount: props.currentUser.default_account
                });
            }
        }

        this.state = initialState;    

        this.handleChange = this.handleChange.bind(this);
        this.handleAccountChange = this.handleAccountChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    handleChange(event) {
        this.setState({
            [event.target.name]: (event.target.type === 'checkbox') ? event.target.checked: event.target.value
        })
    }

    handleAccountChange(event) {
        this.setState({
            [event.target.name]: event.target.value,
            ["UserCust" + event.target.value]: true
        })
    }

    handleSubmit(event) {
        event.preventDefault();
        const formData = new FormData(document.getElementById('userForm'));

        if(formData.get("password") !== formData.get("confirmPassword")) {
            alert('Passwords do not match!');
            return false;
        }

        this.props.onFormSubmit(formData);
    }

    handleCancel(event) {
        this.props.router.navigate(-1);
    }

    render() {

        var regionOptions = null;

        if (this.props.regions) {
            var sortedRegions = _.sortBy(this.props.regions, ['region_name']);
            regionOptions = sortedRegions.map(r => <option key={r.region_id} value={r.region_id}>{r.region_name}</option>);
        }

        var accountsInputNames = _.filter(Object.keys(this.state), k => _.startsWith(k,"UserCust"));

        const accountFields = accountsInputNames.map(
            (accountFieldName, index) =>
            <div className="form-group form-group-sm" key={accountFieldName}>
                <div className="col-sm-10">
                    <div className="checkbox">
                        <label>
                            {
                                _.endsWith(accountFieldName, this.state.defaultAccount) &&
                                <input id={"hiddenInput" + accountFieldName}
                                    name={accountFieldName}
                                    type="hidden"
                                    onChange={this.handleChange}
                                    value="on"
                                    />
                            }
                            <input id={"input" + accountFieldName}
                                name={accountFieldName}
                                type="checkbox"
                                checked={this.state[accountFieldName] || _.endsWith(accountFieldName, this.state.defaultAccount)}
                                onChange={this.handleChange}
                                disabled={_.endsWith(accountFieldName, this.state.defaultAccount)}
                                />
                            {this.props.currentUser.accounts[index].value + '-' + this.props.currentUser.accounts[index].label}
                        </label>
                    </div>
                </div>
            </div>
        );

        var accountOptions = null;

        if (this.props.currentUser) {
            var sortedAccounts = _.sortBy(this.props.currentUser.accounts, ['label']);
            accountOptions = sortedAccounts.map(
                (a) => <option key={a.value} value={a.value}>{a.label}</option>
                );
        }

        return (
            <form id="userForm" styleName="styles.form" onSubmit={this.handleSubmit}>
                <input id="inputUserId" name="userId" type="hidden" value={this.state.userId} />
                <div className="row">
                    <div className="col-xs-12 col-sm-6 col-md-4">
                        <fieldset>
                            <legend className="groupHeader">Details</legend>
                            <div className="form-group form-group-sm">
                                <label>*Email</label>
                                <input id="inputEmail" name="email" type={(this.props.isNew ? "email" : "hidden")} className="form-control" value={this.state.email} onChange={this.handleChange} required/>
                                {
                                    !this.props.isNew && <p className="form-control-static">{this.state.email}</p>
                                }
                            </div>
                            <div className="form-group form-group-sm">
                                <label htmlFor="inputFullName">*Full Name</label>
                                <input id="inputFullName" name="userName" type="text" className="form-control" value={this.state.userName} onChange={this.handleChange} required/>
                            </div>
                            <div className="form-group form-group-sm">
                                <label htmlFor="inputRegion">Region</label>  
                                <select className="form-control" name="region" value={this.state.region} onChange={this.handleChange}>
                                    {regionOptions}
                                </select>
                            </div>
                            <div className="form-group form-group-sm">
                                <label htmlFor="inputPhone">*Phone Number</label>
                                <input id="inputPhone" name="phone" type="text" className="form-control" value={this.state.phone} onChange={this.handleChange} required/>
                            </div>
                            <div className="checkbox">
                                <label htmlFor="inputAllow_uem">
                                    <input id="inputAllow_uem" name="allow_uem" type="checkbox" className="checkbox" checked={this.state.allow_uem} onChange={this.handleChange} />Unsolicited E-mails
                                </label>
                            </div>
                            <div className="form-group form-group-sm">
                                <label htmlFor="inputPassword">Web Password</label>
                                <input id="inputPassword" name="password" type="password" className="form-control" value={this.state.password} onChange={this.handleChange} />
                            </div>
                            <div className="form-group form-group-sm">
                                <label htmlFor="inputConfirmPassword">Retype Password</label>
                                <input id="inputConfirmPassword" name="confirmPassword" type="password" className="form-control" value={this.state.confirmPassword} onChange={this.handleChange} />
                            </div>
                            <div className="form-group form-group-sm">
                                <div className="checkbox">    
                                    <label htmlFor="inputActive">
                                        <input id="inputActive" name="active" type="checkbox" className="checkbox" checked={this.state.active} onChange={this.handleChange} />Active
                                    </label>
                                </div>
                            </div>
                            <div className="form-group form-group-sm">
                                <label htmlFor="inputDefaultAccount">Default Customer</label>
                                <select className="form-control" name="defaultAccount" value={this.state.defaultAccount} onChange={this.handleAccountChange}>
                                    {accountOptions}
                                </select>
                            </div>
                        </fieldset>
                    </div>
                
                    <div className="col-xs-12 col-sm-6 col-md-4">
                        <fieldset>
                            <legend className="groupHeader">Accounts</legend>
                            {accountFields}
                        </fieldset>
                    </div>
                    <div className="col-xs-12 col-sm-6 col-md-4">
                        <UserEditPermissions
                            permissions={this.props.permissions}
                            privileges={(this.props.editUser ? this.props.editUser.privileges : [])}
                            />
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-12">
                        <button type="submit" className="btn btn-default btn-dl-green">SAVE</button>
                        <button type="button" className="btn btn-dfault btn-dl-green" onClick={this.handleCancel}>CANCEL</button>
                    </div>
                </div>
            </form>
            );
    }
}

export default withRouter(UserEditForm);